<template>
  <div class="join-dyp">
    <div class="charity" v-if="currentStep === 'charity'">
      <v-row align="center">
        <v-col class="text-center">
          <v-img src="../assets/2026/step-1.png" />
        </v-col>
      </v-row>
      
      <v-row>
        <v-col>
          <p>Choose from 3 local charities near and dear to our hearts.</p>
        </v-col>
      </v-row>

      <v-row v-if="!charities && isCharitiesLoading">
        <v-col class="text-center">
          <heart-loader />
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <h2 class="mb-2">Choose your charity</h2>
          <v-row v-if="charities && !isCharitiesLoading">
            <v-col @click="selectCharity(charity)" cols="12" v-for="(charity, i) in charities" :key="charity.id" class="mb-0 pb-0">
              <div class="round-block tan" :class="{ 'selected': selectedCharityId === charity.id }">
                <v-row :id="i"  align="center">
                  <v-col cols="3">
                    <v-img :src="require(`../assets/2026/${charity.logoUrl}`)" />
                  </v-col>
                  <v-col cols="9">
                    <p>{{ charity.description }}</p>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="mt-5">
          <v-btn
            @click="next('commitment')"
            x-large
            color="#A9421B"
            :dark="selectedCharityId !== null"
            depressed
            block
            :disabled="selectedCharityId === null">
            Next: Choose your Charity
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <div class="commitment" v-if="currentStep === 'commitment'">
      <v-row align="center">
        <v-col class="text-center" @click="back('charity')">
          <v-img src="../assets/2026/step-2.png" />
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <p>Choose how many classes you want to commit to between 6/1/26 to 8/31/26. The more classes you commit to the more Ra will add to your donation!</p>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="mb-5">
          <h2 class="mb-2">Choose your commitment</h2>
          <v-row>
            <v-col @click="selectCommitment(commitment)" cols="12" v-for="(commitment, i) in commitments" :key="commitment.id" class="mb-0 pb-0">
              <div class="round-block tan commitment" :class="{ 'selected': selectedCommitmentId === commitment.id }">
                <v-row :id="i"  align="center">
                  <v-col>
                    <p class="text-center">I will take <span>{{ commitment.classes }}</span> classes</p>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="mb-0">
          <h2>Choose Your Home Studio</h2>
          <p class="mb-0">We will hang decorative cards at the studios for each participant! Let us know which location you'd like to see your name hung up.</p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <div class="round-block tan">
            <v-row>
              <v-col>
                <v-select
                  :loading="locationsLoading"
                  :items="locations"
                  v-model="selectedHomeLocation"
                  item-text="attributes.name"
                  item-value="attributes.name"
                  label="Select your home studio"
                  outlined
                  hide-details
                ></v-select>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>

      <!--<v-row>
        <v-col class="mb-0">
          <h2>Choose Your Start Date</h2>
          <p class="mb-0">You can start your commitment at anytime in between June 1st and August 31st. Pick a start date that fits your summer plans!</p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <div class="round-block tan">
            <v-row>
              <v-col>
                <v-dialog
                  ref="dialog"
                  v-model="modal"
                  :return-value.sync="date"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="formattedDate"
                      color="#53745C"
                      append-icon="mdi-calendar"
                      outlined
                      hide-details
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    scrollable
                    color="#53745C"
                    :allowed-dates="allowedDates"
                    :min="minDate"
                    :max="maxDate"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="#53745C"
                      @click="modal = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="#53745C"
                      @click="$refs.dialog.save(date)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col cols="12" v-if="endDateWarning">
          <v-alert type="info">
            Heads up! The commitment you have selected extends past the end of the Summer of Service event. You can continue with this selection but you will have {{ endDateWarningDays }} days to complete your {{ selectedCommitment.classes }} class commitment.
          </v-alert>
        </v-col>
      </v-row> -->

      <v-row>
        <v-col class="mt-5">
          <v-btn
            @click="next('why')"
            x-large
            color="#A9421B"
            :dark="(selectedHomeLocation !== null && selectedCommitmentId !== null)"
            depressed
            block
            :disabled="(selectedHomeLocation === null || selectedCommitmentId === null)">
            Next: Commit your Commitment
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <div class="why" v-if="currentStep === 'why'">
      <v-row align="center">
        <v-col class="text-center" @click="back('commitment')">
          <v-img src="../assets/2026/step-3.png" />
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <p>Tell us what inspired you to pick the charity for this year’s yoga drive. These messages will appear on your participation banner at your home studio.</p>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="mb-5">
          <h2 class="mb-2">What inspired you to pick the charity?</h2>
          <v-textarea
            v-model="inspirationText"
            max="280"
            rows="8"
            outlined
            hide-details
          ></v-textarea>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="mt-5">
          <v-btn
            @click="next('review')"
            x-large
            color="#A9421B"
            :dark="inspirationText !== '' && inspirationText !== null && inspirationText.length <= 280"
            depressed
            block
            :disabled="inspirationText === '' || inspirationText === null || inspirationText.length > 280"
          >
            Next: Share your Inspiration
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <div class="review" v-if="currentStep === 'review'">
      <v-row align="center">
        <v-col class="text-center" @click="back('commitment')">
          <v-img src="../assets/2026/step-4.png" />
        </v-col>
      </v-row>

      <v-row>
        <v-col class="text-center">
          <h2>Details of your commitment</h2>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-btn color="#A9421B" block dark depressed @click="changeCommitment()">Edit my commitment</v-btn>
        </v-col>
      </v-row>

      <v-row class="mb-5">

        <v-col cols="6">
          <div class="round-block tan text-center">
            <v-row justify="center" align="center" style="min-height: 170px; max-height: 170px;">
              <v-col>
                <p class="mb-0">Your Charity</p>
                <v-row justify="center">
                  <v-col cols="6">
                    <v-img :src="require(`../assets/2026/${selectedCharity.logoUrl}`)" />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </v-col>

        <v-col cols="6">
          <div class="round-block tan text-center">
            <v-row justify="center" align="center" style="min-height: 170px;">
              <v-col>
                <p class="mb-4">Your Commitment</p>
                <p class="commitment mb-0"><span>{{ selectedCommitment.classes }}</span> classes</p>
              </v-col>
            </v-row>
          </div>
        </v-col>
        
        <v-col cols="6">
          <div class="round-block tan text-center">
            <v-row justify="center" align="center" style="min-height: 170px;">
              <v-col>
                <p class="mb-4">Your Donation</p>
                <h1>$10</h1>
              </v-col>
            </v-row>
          </div>
        </v-col>

        <v-col cols="6">
          <div class="round-block tan text-center">
            <v-row justify="center" align="center" style="min-height: 170px;">
              <v-col>
                <p class="mb-4">Your Home Studio</p>
                <h2>{{ selectedHomeLocation }}</h2>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-checkbox
            color="#A9421B"
            label="I want RA YOGA to make my participant banner for me."
            v-model="printInStudioDisplay"
          ></v-checkbox>
        </v-col>
      </v-row>

      <v-row>
        <v-col v-if="error" cols="12">
          <v-alert v-if="error" color="red" type="error" @input="clearError" dismissible>
            {{ error }}
          </v-alert>
        </v-col>
        <v-col cols="12">
          <v-btn
            v-if="!hasSignedUp"
            @click="goToCheckout"
            x-large
            color="#A9421B"
            :dark="!isCheckoutPending"
            depressed
            :loading="isCheckoutPending"
            :disabled="isCheckoutPending"
            block>
            Next: Make My Donation
          </v-btn>

          <v-btn
            v-if="hasSignedUp"
            @click="goToCheckoutAlreadySignedUp"
            x-large
            color="#A9421B"
            :dark="!isCheckoutPending"
            depressed
            :loading="isCheckoutPending"
            :disabled="isCheckoutPending"
            block>
            Next: Make My Donation
          </v-btn>
        </v-col>
        <v-col cols="12" class="text-center">
          <p><small>*100% of donations go to the charity of your choice</small></p>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { DateTime } from 'luxon'

import HeartLoader from '../components/HeartLoader.vue'

export default {
  name: 'JoinView',

  components: {
    HeartLoader
  },

  data() {
    return {
      error: null,
      currentStep: 'charity',
      selectedCharityId: null,
      selectedCharity: null,
      selectedCommitmentId: null,
      selectedCommitment: null,
      selectedHomeLocation: null,
      printInStudioDisplay: false,
      modal: false,
      isCharitiesLoading: false,
      isCheckoutPending: false,
      inspirationText: null,
      commitments: [
        {
          id: 1,
          classes: 30,
          duration: 30,
        },
        {
          id: 2,
          classes: 45,
          duration: 60,
        },
        {
          id: 3,
          classes: 60,
          duration: 90,
        },
      ],
      date: null,
    }
  },

  computed: {
    ...mapGetters([
      'isAuthenticated',
      'hasSignedUp',
      'hasPaid'
    ]),
    session() {
      return this.$store.state.session
    },
    user() {
      return this.$store.state.user
    },
    charities() {
      return this.$store.state.charities?.data
    },
    locations() {
      return this.$store.state.locations
    },
    locationsLoading() {
      return this.$store.state.isLocationsLoading
    },
    totalDonation() {
      let total = 0

      switch(this.selectedCommitmentId) {
        case 1:
          total = 20
          break
        case 2:
          total = 25
          break
        case 3:
          total = 30
          break
      }

      return total
    },
    minDate() {
      return this.$store.state.startDate
    },
    maxDate() {
      return this.$store.state.endDate
    },
    formattedDate() {
      return DateTime.fromISO(this.date).toLocaleString(DateTime.DATE_SHORT)
    },
    reviewStartDate() {
      return DateTime.fromISO(this.date).toFormat('LLLL d')
    },
    reviewEndDate() {
      return DateTime.fromISO(this.endDate).toFormat('LLLL d')
    },
    startDate() {
      return DateTime.fromISO(this.date).toISODate()
    },
    endDate() {
      let end = DateTime.fromISO(this.date).plus({ 'days': this.selectedCommitment.duration }).toISODate()

      if (DateTime.fromISO(end).toMillis() > DateTime.fromISO(this.maxDate).toMillis()) {
        end = this.maxDate
      }

      return end
    },
    endDateWarning() {
      if (this.selectedCommitment) {
        let end = DateTime.fromISO(this.date).plus({ 'days': this.selectedCommitment.duration }).toISODate()

        if (DateTime.fromISO(end).toMillis() > DateTime.fromISO(this.maxDate).toMillis()) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    endDateWarningDays() {
      const start = DateTime.fromISO(this.date)
      const end = DateTime.fromISO(this.maxDate)
      const diff = end.diff(start, 'days').toObject()
      return diff.days
    }
  },

  methods: {
    clearError() {
      this.error = null
    },
    selectCharity(charity) {
      this.selectedCharityId = charity.id
      this.selectedCharity = charity
    },
    selectCommitment(commitment) {
      this.selectedCommitmentId = commitment.id
      this.selectedCommitment = commitment
    },
    selecteHomeLocation(location) {
      this.selectedHomeLocation = location
    },
    next(step) {
      this.currentStep = step
    },
    back(step) {
      switch(step) {
        case 'charity':
          this.selectedCommitmentId = null
          this.currentStep = 'charity'
      }
    },
    allowedDates(val) {
      let start = DateTime.fromISO(this.$store.state.startDate).toMillis()
      const end = DateTime.fromISO(this.$store.state.endDate).toMillis()
      const date = DateTime.fromISO(val).toMillis()

      return (date >= start && date <= end)
    },
    async goToCheckout() {
      this.isCheckoutPending = true
      await this.$store.dispatch('createMember', {
        marianaTekId: this.user.id,
        charityId: this.selectedCharityId,
        pledgeClasses: this.selectedCommitment.classes,
        //pledgeStartDate: this.startDate,
        //pledgeEndDate: this.endDate,
        homeStudio: this.selectedHomeLocation,
        printInStudioDisplay: this.printInStudioDisplay,
        customFieldOne: this.inspirationText,
        referral: (this.$store.state.ref) ? this.$store.state.ref : null,
      }).then(async (res) => {
        if (res) {
          await this.$store.dispatch('createStripeCheckout', {
            priceId: this.$store.state.stripeProductId,
          }).then(res => {
            if (res.url) {
              window.location = res.url
              this.isCheckoutPending = false
            }
            this.isCheckoutPending = false
          }).catch(err => {
            console.log(err)
            this.isCheckoutPending = false
          })
        }
      }).catch(err => {
        this.isCheckoutPending = false
        this.error = 'Oops! Something went wrong, please try again.'
        console.log(err)
      })
    },

    async goToCheckoutAlreadySignedUp() {
      this.isCheckoutPending = true
      await this.$store.dispatch('patchMember', {
        id: this.$store.state.member.id,
        charityId: this.selectedCharityId,
        pledgeClasses: this.selectedCommitment.classes,
        //pledgeStartDate: this.startDate,
        //pledgeEndDate: this.endDate,
        homeStudio: this.selectedHomeLocation,
        printInStudioDisplay: this.printInStudioDisplay,
        customFieldOne: this.inspirationText,
      }).then(async (res) => {
        if (res) {
          await this.$store.dispatch('createStripeCheckout', {
            priceId: this.$store.state.stripeProductId,
          }).then(res => {
            if (res.url) {
              window.location = res.url
              this.isCheckoutPending = false
            }
            this.isCheckoutPending = false
          }).catch(err => {
            console.log(err)
            this.isCheckoutPending = false
          })
        }
      })
    },

    changeCommitment() {
      this.currentStep = 'charity'
    }
  },

  async beforeMount() {
    this.isCharitiesLoading = true
    console.log('getting charities')
    await this.$store.dispatch('getCharities')
    this.isCharitiesLoading = false

    await this.$store.dispatch('getLocations')

    this.date = DateTime.now().toISODate()
    console.log(DateTime.now().toISODate())

    if (!this.isAuthenticated) {
      this.$router.push({ name: 'Home' })
    } else {
      console.log('checking for member')
      await this.$store.dispatch('checkForMember')
    }

    if (this.isAuthenticated && this.hasSignedUp && this.hasPaid) {
      this.$router.push({ name: 'LeaderboardRoute' })
    }

    

    //const now = DateTime.now().toMillis()
    //let start = DateTime.fromISO(this.$store.state.startDate).toMillis()
    
    /*if (now >= start) {
      this.date = DateTime.now().toFormat('yyyy-LL-dd')
      console.log(DateTime.now().toFormat('yyyy-LL-dd'))
    } else {*/
    //this.date = DateTime.fromISO(this.$store.state.startDate).toFormat('yyyy-LL-dd')
    //}

    if (this.hasSignedUp && !this.hasPaid) {
      const member = this.$store.state.member

      this.selectedCharityId = member.charityId
      this.selectedCharity = this.charities.find(o => o.id === member.charityId)
      this.selectedCommitment = this.commitments.find(o => o.classes === member.pledgeClasses)
      this.selectedCommitmentId = this.selectedCommitment.id
      this.selectedHomeLocation = member.homeStudio
      this.printInStudioDisplay = member.printInStudioDisplay
      this.inspirationText = member.customFieldOne
      this.date = DateTime.fromISO(member.pledgeStartDate).toISODate()
      this.currentStep = 'review'
    }
  }
}
</script>

<style lang="scss">
.join-dyp {
  .round-block {

    &:hover {
      cursor: pointer;
    }

    p {
      margin-bottom: 0;
      vertical-align: middle;
    }

    &.selected {
      background-color: #E4B465;
      color: #ffffff;
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset;
    }

    &.commitment {
      font-family: "patrick-hand-sc", sans-serif;
      font-weight: 400;
      font-style: normal;
      font-size: 25px;

      span {
        font-size: 48px;
        vertical-align: middle;
      }
    }
  }

  .review .commitment {
    font-family: "patrick-hand-sc", sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 20px;
    line-height: 1.1;

    span {
      font-size: 32px;
    }
  }

  .v-text-field--outlined > .v-input__control > .v-input__slot {
    background-color: #ffffff !important;
  }
}
</style>